export enum ApiErrorCode {
  // Generic errors (common namespace)
  GENERIC_ERROR = 'common:api.error.generic',
  NETWORK_ERROR = 'common:api.error.network',
  UNAUTHORIZED = 'common:api.error.unauthorized',
  FORBIDDEN = 'common:api.error.forbidden',
  NOT_FOUND = 'common:api.error.notFound',

  // Assignment errors
  ASSIGNMENT_LOAD_FAILED = 'authenticated.planner:api.error.loadFailed',
  ASSIGNMENT_CREATE_FAILED = 'authenticated.planner:api.error.createFailed',
  ASSIGNMENT_UPDATE_FAILED = 'authenticated.planner:api.error.updateFailed',
  ASSIGNMENT_DELETE_FAILED = 'authenticated.planner:api.error.deleteFailed',
  ASSIGNMENT_CUT_FAILED = 'authenticated.planner:api.error.cutFailed',
  ASSIGNMENT_DUPLICATE_FAILED = 'authenticated.planner:api.error.duplicateFailed',
  ASSIGNMENT_VALIDATION_FAILED = 'authenticated.planner:api.error.validationFailed',
  ASSIGNMENT_BOOKED_MINUTES_PREVIEW_FAILED = 'authenticated.planner:api.error.bookedMinutesPreviewFailed',

  // Project errors (authenticated.projects namespace)
  PROJECT_NOT_FOUND = 'authenticated.projects:api.error.notFound',
  PROJECT_CREATE_FAILED = 'authenticated.projects:api.error.createFailed',
  PROJECT_UPDATE_FAILED = 'authenticated.projects:api.error.updateFailed',
  PROJECT_DELETE_FAILED = 'authenticated.projects:api.error.deleteFailed',
  PROJECT_ARCHIVE_FAILED = 'authenticated.projects:api.error.archiveFailed',
  PROJECT_UNARCHIVE_FAILED = 'authenticated.projects:api.error.unarchiveFailed',
  PROJECT_LOGO_UPLOAD_FAILED = 'authenticated.projects:api.error.logoUploadFailed',
  PROJECTS_LOAD_FAILED = 'authenticated.projects:api.error.loadFailed',
  PROJECT_AVAILABLE_ARCHIVE_DATE_FAILED = 'authenticated.projects:api.error.availableArchiveDateFailed',
  PROJECT_AVAILABLE_UNARCHIVE_DATE_FAILED = 'authenticated.projects:api.error.availableUnarchiveDateFailed',
  PROJECT_CHANGES_LOAD_FAILED = 'authenticated.projects:api.error.changesLoadFailed',
  PROJECT_INFO_CONFLICTS_LOAD_FAILED = 'authenticated.projects:api.error.infoConflictsLoadFailed',
  PROJECT_BILLING_CONFLICTS_LOAD_FAILED = 'authenticated.projects:api.error.billingConflictsLoadFailed',
  PROJECT_CHANGE_DELETE_FAILED = 'authenticated.projects:api.error.changeDeleteFailed',

  // Custom attributes errors (authenticated.projects namespace)
  CUSTOM_ATTRIBUTES_LOAD_FAILED = 'authenticated.projects:api.error.customAttributes.loadFailed',

  // Industry errors (authenticated.projects namespace)
  INDUSTRIES_LOAD_FAILED = 'authenticated.projects:api.error.industries.loadFailed',

  // Integration errors (authenticated.projects namespace)
  INTEGRATIONS_LOAD_FAILED = 'authenticated.projects:api.error.integrations.loadFailed',

  // Client errors (authenticated.clients namespace)
  CLIENT_NOT_FOUND = 'authenticated.clients:api.error.notFound',
  CLIENT_CREATE_FAILED = 'authenticated.clients:api.error.createFailed',
  CLIENT_UPDATE_FAILED = 'authenticated.clients:api.error.updateFailed',
  CLIENT_DELETE_FAILED = 'authenticated.clients:api.error.deleteFailed',
  CLIENT_ARCHIVE_FAILED = 'authenticated.clients:api.error.archiveFailed',
  CLIENT_UNARCHIVE_FAILED = 'authenticated.clients:api.error.unarchiveFailed',
  CLIENT_LOGO_UPLOAD_FAILED = 'authenticated.clients:api.error.logoUploadFailed',
  CLIENTS_LOAD_FAILED = 'authenticated.clients:api.error.loadFailed',

  // Team errors (authenticated.team namespace)
  TEAM_MEMBER_NOT_FOUND = 'authenticated.team:api.error.notFound',
  TEAM_MEMBER_CREATE_FAILED = 'authenticated.team:api.error.createFailed',
  TEAM_MEMBER_UPDATE_FAILED = 'authenticated.team:api.error.updateFailed',
  TEAM_MEMBER_DELETE_FAILED = 'authenticated.team:api.error.deleteFailed',
  TEAM_MEMBER_ARCHIVE_FAILED = 'authenticated.team:api.error.archiveFailed',
  TEAM_MEMBER_UNARCHIVE_FAILED = 'authenticated.team:api.error.unarchiveFailed',
  TEAM_MEMBER_INVITE_FAILED = 'authenticated.team:api.error.inviteFailed',
  TEAM_MEMBER_REINVITE_FAILED = 'authenticated.team:api.error.reinviteFailed',
  TEAM_MEMBER_REVOKE_ACCESS_FAILED = 'authenticated.team:api.error.revokeAccessFailed',
  TEAM_MEMBER_AVAILABLE_ARCHIVE_DATE_FAILED = 'authenticated.team:api.error.availableArchiveDateFailed',
  TEAM_MEMBER_AVAILABLE_UNARCHIVE_DATE_FAILED = 'authenticated.team:api.error.availableUnarchiveDateFailed',
  TEAM_MEMBER_AVATAR_UPLOAD_FAILED = 'authenticated.team:api.error.avatarUploadFailed',
  TEAM_MEMBER_AVATAR_DELETE_FAILED = 'authenticated.team:api.error.avatarDeleteFailed',
  TEAM_MEMBERS_LOAD_FAILED = 'authenticated.team:api.error.membersLoadFailed',
  TEAM_MEMBER_LAST_ASSIGNMENT_LOAD_FAILED = 'authenticated.team:api.error.lastAssignmentLoadFailed',
  TEAM_MEMBER_CHANGES_LOAD_FAILED = 'authenticated.team:api.error.changesLoadFailed',
  TEAM_MEMBER_CHANGE_DELETE_FAILED = 'authenticated.team:api.error.changeDeleteFailed',
  TEAM_MEMBER_INFO_CONFLICTS_LOAD_FAILED = 'authenticated.team:api.error.infoConflictsLoadFailed',
  TEAM_MEMBER_BILLING_CONFLICTS_LOAD_FAILED = 'authenticated.team:api.error.billingConflictsLoadFailed',
  TEAM_MEMBER_CAPACITY_CONFLICTS_LOAD_FAILED = 'authenticated.team:api.error.capacityConflictsLoadFailed',

  // Organization errors (authenticated.organization namespace)
  ORGANIZATION_DEFAULTS_LOAD_FAILED = 'common:api.error.organizationDefaultsLoadFailed',
  ORGANIZATION_LOAD_FAILED = 'authenticated.organization:api.error.organizationLoadFailed',
  ORGANIZATION_UPDATE_FAILED = 'authenticated.organization:api.error.organizationUpdateFailed',
  ORGANIZATION_DELETE_FAILED = 'authenticated.organization:api.error.organizationDeleteFailed',

  // Currency errors (common namespace)
  CURRENCIES_LOAD_FAILED = 'common:api.error.currenciesLoadFailed',
  EXCHANGE_RATES_LOAD_FAILED = 'common:api.error.exchangeRatesLoadFailed',

  // Countries errors (authenticated.organization namespace)
  COUNTRIES_LOAD_FAILED = 'authenticated.organization:api.error.countriesLoadFailed',

  // Timezones errors (authenticated.organization namespace)
  TIMEZONES_LOAD_FAILED = 'authenticated.organization:api.error.timezonesLoadFailed',

  // Manager errors (common namespace)
  MANAGERS_LOAD_FAILED = 'common:api.error.managersLoadFailed',

  // User groups errors (common namespace)
  USER_GROUPS_LOAD_FAILED = 'common:api.error.userGroupsLoadFailed',

  // Permissions errors (authenticated.settings namespace)
  PERMISSIONS_LOAD_FAILED = 'authenticated.settings:api.error.permissions.loadFailed',
  PERMISSIONS_UPDATE_FAILED = 'authenticated.settings:api.error.permissions.updateFailed',

  // User group CRUD errors (authenticated.settings namespace)
  USER_GROUP_CREATE_FAILED = 'authenticated.settings:api.error.userGroups.createFailed',
  USER_GROUP_RENAME_FAILED = 'authenticated.settings:api.error.userGroups.renameFailed',
  USER_GROUP_DELETE_FAILED = 'authenticated.settings:api.error.userGroups.deleteFailed',
  USER_GROUP_SET_DEFAULT_FAILED = 'authenticated.settings:api.error.userGroups.setDefaultFailed',

  // Member access errors (authenticated.settings namespace)
  MEMBER_ACCESS_LOAD_FAILED = 'authenticated.settings:api.error.memberAccess.loadFailed',
  MEMBER_ACCESS_UPDATE_FAILED = 'authenticated.settings:api.error.memberAccess.updateFailed',
  BULK_INVITE_TEAM_MEMBERS_FAILED = 'authenticated.settings:api.error.memberAccess.bulkInviteFailed',

  // Custom attributes errors (authenticated.settings namespace)
  CUSTOM_ATTRIBUTES_SAVE_FAILED = 'authenticated.settings:api.error.customAttributes.saveFailed',
  CUSTOM_ATTRIBUTES_DELETE_FAILED = 'authenticated.settings:api.error.customAttributes.deleteFailed',

  // Time-off type changes errors (authenticated.settings namespace)
  TIME_OFF_TYPES_LOAD_FAILED = 'authenticated.settings:api.error.timeOffTypes.loadFailed',
  TIME_OFF_TYPE_DETAILS_LOAD_FAILED = 'authenticated.settings:api.error.timeOffTypes.detailsLoadFailed',
  TIME_OFF_TYPE_UPDATE_FAILED = 'authenticated.settings:api.error.timeOffTypes.updateFailed',
  TIME_OFF_TYPE_CHANGES_LOAD_FAILED = 'authenticated.settings:api.error.timeOffTypeChanges.loadFailed',
  TIME_OFF_TYPE_CHANGE_DELETE_FAILED = 'authenticated.settings:api.error.timeOffTypeChanges.deleteFailed',

  // Integration errors (authenticated.settings namespace)
  INTEGRATION_SYNC_FAILED = 'authenticated.settings:api.error.integrations.syncFailed',
  INTEGRATION_CONFLICTS_LOAD_FAILED = 'authenticated.settings:api.error.integrations.conflictsLoadFailed',
  INTEGRATION_OAUTH_URL_FAILED = 'authenticated.settings:api.error.integrations.oauthUrlFailed',
  INTEGRATION_OAUTH_CALLBACK_FAILED = 'authenticated.settings:api.error.integrations.oauthCallbackFailed',
  CONNECT_AI_FAILED = 'authenticated.connectAi:api.error.handoffFailed',
  INTEGRATION_TEMPO_CONFIGURE_FAILED = 'authenticated.settings:api.error.integrations.tempoConfigureFailed',
  INTEGRATION_CLOCKIFY_CONFIGURE_FAILED = 'authenticated.settings:api.error.integrations.clockifyConfigureFailed',
  REQUESTED_INTEGRATIONS_CREATE_FAILED = 'authenticated.onboarding.integrations:api.error.requestedIntegrationsCreateFailed',

  // Onboarding clients errors
  ONBOARDING_CLIENTS_LOAD_FAILED = 'authenticated.onboarding.clients:api.error.loadFailed',
  ONBOARDING_CLIENTS_UPSERT_FAILED = 'authenticated.onboarding.clients:api.error.upsertFailed',
  ONBOARDING_CLIENTS_UPDATE_FAILED = 'authenticated.onboarding.clients:api.error.updateFailed',
  ONBOARDING_CLIENTS_DELETE_FAILED = 'authenticated.onboarding.clients:api.error.deleteFailed',
  ONBOARDING_CLIENTS_MERGE_FAILED = 'authenticated.onboarding.clients:api.error.mergeFailed',
  ONBOARDING_CLIENTS_SUBMIT_FAILED = 'authenticated.onboarding.clients:api.error.submitFailed',
  ONBOARDING_CLIENTS_IMPORT_FAILED = 'authenticated.onboarding.clients:api.error.importFailed',
  ONBOARDING_CLIENTS_VALIDATION_REPORT_FAILED = 'authenticated.onboarding.clients:api.error.validationReportFailed',

  // Onboarding projects errors
  ONBOARDING_PROJECTS_LOAD_FAILED = 'authenticated.onboarding.projects:api.error.loadFailed',
  ONBOARDING_PROJECTS_UPSERT_FAILED = 'authenticated.onboarding.projects:api.error.upsertFailed',
  ONBOARDING_PROJECTS_UPDATE_FAILED = 'authenticated.onboarding.projects:api.error.updateFailed',
  ONBOARDING_PROJECTS_DELETE_FAILED = 'authenticated.onboarding.projects:api.error.deleteFailed',
  ONBOARDING_PROJECTS_MERGE_FAILED = 'authenticated.onboarding.projects:api.error.mergeFailed',
  ONBOARDING_PROJECTS_SUBMIT_FAILED = 'authenticated.onboarding.projects:api.error.submitFailed',
  ONBOARDING_PROJECTS_IMPORT_FAILED = 'authenticated.onboarding.projects:api.error.importFailed',
  ONBOARDING_PROJECTS_VALIDATION_REPORT_FAILED = 'authenticated.onboarding.projects:api.error.validationReportFailed',

  // Onboarding employees errors
  ONBOARDING_EMPLOYEES_LOAD_FAILED = 'authenticated.onboarding.team:api.error.loadFailed',
  ONBOARDING_EMPLOYEES_UPSERT_FAILED = 'authenticated.onboarding.team:api.error.upsertFailed',
  ONBOARDING_EMPLOYEES_UPDATE_FAILED = 'authenticated.onboarding.team:api.error.updateFailed',
  ONBOARDING_EMPLOYEES_DELETE_FAILED = 'authenticated.onboarding.team:api.error.deleteFailed',
  ONBOARDING_EMPLOYEES_MERGE_FAILED = 'authenticated.onboarding.team:api.error.mergeFailed',
  ONBOARDING_EMPLOYEES_SUBMIT_FAILED = 'authenticated.onboarding.team:api.error.submitFailed',
  ONBOARDING_EMPLOYEES_IMPORT_FAILED = 'authenticated.onboarding.team:api.error.importFailed',
  ONBOARDING_EMPLOYEES_VALIDATION_REPORT_FAILED = 'authenticated.onboarding.team:api.error.validationReportFailed',

  // Onboarding organization errors
  ONBOARDING_FLOW_LOAD_FAILED = 'authenticated.onboarding.common:api.error.flowLoadFailed',

  // Onboarding integrations errors
  ONBOARDING_INTEGRATIONS_SUBMIT_FAILED = 'authenticated.onboarding.integrations:api.error.submitFailed',
  ONBOARDING_GOOGLE_ACCOUNT_ID_FAILED = 'authenticated.onboarding.integrations:api.error.googleAccountIdFailed',
  ONBOARDING_GOOGLE_CONNECT_FAILED = 'authenticated.onboarding.integrations:api.error.googleConnectFailed',

  // Onboarding completion errors
  ONBOARDING_COMPLETE_FAILED = 'authenticated.onboarding.common:api.error.completeFailed',
  // Invoice errors (authenticated.invoices namespace)
  INVOICES_LOAD_FAILED = 'authenticated.invoices:api.error.loadFailed',
  INVOICE_DETAILS_LOAD_FAILED = 'authenticated.invoices:api.error.detailsLoadFailed',
  INVOICE_UPDATE_FAILED = 'authenticated.invoices:api.error.updateFailed',
  INVOICES_GENERATED_LOAD_FAILED = 'authenticated.invoices:api.error.generatedLoadFailed',
  INVOICES_CREATE_FAILED = 'authenticated.invoices:api.error.createFailed',
  INVOICE_DELETE_FAILED = 'authenticated.invoices:api.error.deleteFailed',
  INVOICE_JOB_STATUS_LOAD_FAILED = 'authenticated.invoices:api.error.jobStatusLoadFailed',
  INVOICE_RETRY_FAILED = 'authenticated.invoices:api.error.retryFailed',

  // Bill errors (authenticated.bills namespace)
  BILLS_LOAD_FAILED = 'authenticated.bills:api.error.loadFailed',
  BILL_DETAILS_LOAD_FAILED = 'authenticated.bills:api.error.detailsLoadFailed',
  BILL_UPDATE_FAILED = 'authenticated.bills:api.error.updateFailed',
  BILLS_GENERATED_LOAD_FAILED = 'authenticated.bills:api.error.generatedLoadFailed',
  BILLS_CREATE_FAILED = 'authenticated.bills:api.error.createFailed',
  BILL_DELETE_FAILED = 'authenticated.bills:api.error.deleteFailed',
  BILL_RETRY_FAILED = 'authenticated.bills:api.error.retryFailed',

  // Overhead errors (authenticated.overheads namespace)
  OVERHEADS_LOAD_FAILED = 'authenticated.overheads:api.error.loadFailed',
  OVERHEADS_SUMMARY_LOAD_FAILED = 'authenticated.overheads:api.error.summaryLoadFailed',
  OVERHEAD_CREATE_FAILED = 'authenticated.overheads:api.error.createFailed',
  OVERHEAD_UPDATE_FAILED = 'authenticated.overheads:api.error.updateFailed',
  OVERHEAD_DELETE_FAILED = 'authenticated.overheads:api.error.deleteFailed',

  // Time Tracking errors (authenticated.timeTracking namespace)
  TIME_TRACKS_LOAD_FAILED = 'authenticated.timeTracking:api.error.timeTracksLoadFailed',
  WEEKLY_SUMMARY_LOAD_FAILED = 'authenticated.timeTracking:api.error.weeklySummaryLoadFailed',
  TIME_TRACK_ADD_FAILED = 'authenticated.timeTracking:api.error.timeTrackAddFailed',
  TIME_TRACK_UPDATE_FAILED = 'authenticated.timeTracking:api.error.timeTrackUpdateFailed',
  TIME_TRACK_DELETE_FAILED = 'authenticated.timeTracking:api.error.timeTrackDeleteFailed',
  APPROVALS_LOAD_FAILED = 'authenticated.timeTracking:api.error.approvalsLoadFailed',
  APPROVALS_APPROVE_FAILED = 'authenticated.timeTracking:api.error.approvalApproveFailed',
  APPROVALS_UNAPPROVE_FAILED = 'authenticated.timeTracking:api.error.approvalUnapproveFailed',
  APPROVALS_EDIT_FAILED = 'authenticated.timeTracking:api.error.approvalEditFailed',
  ACTIVE_TIMER_LOAD_FAILED = 'authenticated.timeTracking:api.error.activeTimerLoadFailed',
  ACTIVE_TIMER_START_FAILED = 'authenticated.timeTracking:api.error.activeTimerStartFailed',
  ACTIVE_TIMER_PAUSE_FAILED = 'authenticated.timeTracking:api.error.activeTimerPauseFailed',
  ACTIVE_TIMER_RESUME_FAILED = 'authenticated.timeTracking:api.error.activeTimerResumeFailed',
  ACTIVE_TIMER_UPDATE_FAILED = 'authenticated.timeTracking:api.error.activeTimerUpdateFailed',
  ACTIVE_TIMER_STOP_FAILED = 'authenticated.timeTracking:api.error.activeTimerStopFailed',
  ACTIVE_TIMER_DISCARD_FAILED = 'authenticated.timeTracking:api.error.activeTimerDiscardFailed',
  TIME_OFF_DAYS_LOAD_FAILED = 'authenticated.timeTracking:api.error.timeOffDaysLoadFailed',
  // Demo errors (common namespace)
  DEMO_STATUS_LOAD_FAILED = 'common:api.error.demoStatusLoadFailed',

  // Notification errors (authenticated.notifications namespace)
  DEVICE_REGISTER_FAILED = 'authenticated.notifications:api.error.deviceRegisterFailed',
  DEVICES_LOAD_FAILED = 'authenticated.notifications:api.error.devicesLoadFailed',
  DEVICE_REMOVE_FAILED = 'authenticated.notifications:api.error.deviceRemoveFailed',

  // Notification errors (authenticated.notifications namespace)
  NOTIFICATIONS_LOAD_FAILED = 'authenticated.notifications:api.error.loadFailed',
  NOTIFICATION_MARK_READ_FAILED = 'authenticated.notifications:api.error.markReadFailed',
  NOTIFICATIONS_MARK_ALL_READ_FAILED = 'authenticated.notifications:api.error.markAllReadFailed',
  NOTIFICATION_DELETE_FAILED = 'authenticated.notifications:api.error.deleteFailed',
  NOTIFICATIONS_DELETE_ALL_FAILED = 'authenticated.notifications:api.error.deleteAllFailed',

  // Profile errors (authenticated.settings namespace)
  PROFILE_AVATAR_UPLOAD_FAILED = 'authenticated.settings:api.error.profile.avatarUploadFailed',
  PROFILE_AVATAR_DELETE_FAILED = 'authenticated.settings:api.error.profile.avatarDeleteFailed',

  // Support request errors (common namespace)
  SUPPORT_REQUEST_CREATE_FAILED = 'common:api.error.supportRequestCreateFailed',

  // Reports errors (authenticated.reports namespace)
  REPORTS_LOAD_FAILED = 'authenticated.reports:api.error.loadFailed',
  REPORT_LOAD_FAILED = 'authenticated.reports:api.error.reportLoadFailed',
  REPORT_CREATE_FAILED = 'authenticated.reports:api.error.createFailed',
  REPORT_UPDATE_FAILED = 'authenticated.reports:api.error.updateFailed',
  REPORT_DELETE_FAILED = 'authenticated.reports:api.error.deleteFailed',
  REPORT_DATA_LOAD_FAILED = 'authenticated.reports:api.error.dataLoadFailed',
  REPORT_DATASET_CREATE_FAILED = 'authenticated.reports:api.error.datasetCreateFailed',
  REPORT_ELEMENT_CREATE_FAILED = 'authenticated.reports:api.error.elementCreateFailed',
  REPORT_ELEMENT_UPDATE_FAILED = 'authenticated.reports:api.error.elementUpdateFailed',
  REPORT_ELEMENT_DELETE_FAILED = 'authenticated.reports:api.error.elementDeleteFailed',
  REPORT_ELEMENT_CHANGES_APPLY_FAILED = 'authenticated.reports:api.error.elementChangesApplyFailed',
  REPORT_AI_GENERATE_FAILED = 'authenticated.reports:api.error.aiGenerateFailed',
  FORMULA_ENTRIES_LOAD_FAILED = 'authenticated.reports:api.error.formulaEntriesLoadFailed',
  FORMULA_ENTRY_CREATE_FAILED = 'authenticated.reports:api.error.formulaEntryCreateFailed',
  FORMULA_ENTRY_UPDATE_FAILED = 'authenticated.reports:api.error.formulaEntryUpdateFailed',
  FORMULA_ENTRY_DELETE_FAILED = 'authenticated.reports:api.error.formulaEntryDeleteFailed',

  // Payment details errors (authenticated.settings / authenticated.invoices namespaces)
  PAYMENT_DETAILS_LOAD_FAILED = 'authenticated.settings:api.error.paymentDetails.loadFailed',
  PAYMENT_DETAILS_CREATE_FAILED = 'authenticated.settings:api.error.paymentDetails.createFailed',
  PAYMENT_DETAILS_UPDATE_FAILED = 'authenticated.settings:api.error.paymentDetails.updateFailed',
  PAYMENT_DETAILS_DELETE_FAILED = 'authenticated.settings:api.error.paymentDetails.deleteFailed',
  PAYMENT_DETAILS_OPTIONS_LOAD_FAILED = 'authenticated.invoices:api.error.paymentDetailsLoadFailed',
}
